import { billingPortalConfig, mobileConfig } from '../../commons/config';
import { BillingPortal } from './BillingPortal';
import { BillingManagement } from './BillingManagement';
import React from 'react';

export const BillingContainer = (props: { source: string }) => {
  const { source } = props;
  return billingPortalConfig.enabled ? (
    mobileConfig().growegyMobilePlatform !== 'ios' || billingPortalConfig.showBillingPortalInIos ? (
      <BillingPortal source={source} />
    ) : (
      <div className="billing__account-management-disabled-banner">
        Account management features are available on our web platform.
      </div>
    )
  ) : (
    <BillingManagement />
  );
};
